import React, { Component } from 'react';
import 'basscss/css/basscss.css';
import '../static/css/Defaults.css';
import '../static/css/Components.css';
import ApperContainer from '../containers/ApperContainer';

class Apper extends Component {
  render() {
    return (
      <div className="App">
        <ApperContainer params={this.props.params} search={this.props.location.search} path={this.props.location.pathname} query={this.props.location.query}  />
      </div>
    );
  }
}

export default Apper;



/** WEBPACK FOOTER **
 ** ./src/containers/App.js
 **/